<ion-header>
    <ion-toolbar color="primary">
        <ion-segment
            (ionChange)="selectTab($any($event).detail.value)"
            [value]="shownTab()"
            class="background-primary panel-tabs"
            data-testid="patient-side-panel-content-tabs-p8d4n6cs"
            mode="ios">
            @for (tab of tabs(); track tab.value) {
                <ion-segment-button
                    [attr.data-testid]="'patient-side-panel-content-tab-' + tab.value"
                    [value]="tab.value"
                    class="ios-button">
                    <div class="panel-tab">
                        <curafida-app-icon
                            [iconColour]="shownTab() === tab.value ? IconColour.PRIMARY : IconColour.PRIMARY_CONTRAST"
                            [iconName]="tab.icon"
                            [iconSizeType]="IconSizeTyp.segment"></curafida-app-icon>
                        <span class="panel-tab-label">{{ tab.name | translate }}</span>
                    </div>
                </ion-segment-button>
            }
        </ion-segment>
        <ion-button
            (click)="close()"
            [attr.aria-label]="'CLOSE' | translate"
            class="close-button"
            data-testid="patient-side-panel-content-close-v6p3x9qe"
            fill="outline"
            slot="end">
            <ion-icon
                name="close"
                style="color: var(--ion-color-primary-contrast)">
            </ion-icon>
        </ion-button>
    </ion-toolbar>
</ion-header>
<ion-content
    class="ion-padding"
    data-testid="patient-side-panel-content-k2m7r4tu">
    <!-- A tab stays rendered once opened, so switching back shows it at once instead of loading it again -->
    @if (openedTabs().has(SegmentType.NOTE)) {
        <lib-note-list
            (notesChanged)="notesChange.emit()"
            [class.ion-hide]="shownTab() !== SegmentType.NOTE"
            [filterSettingName]="noteListFilterSettingName"
            [sharedFilterSettingName]="NOTE_LIST_FILTER_SETTING_NAME"
            [user]="currentPatient()"
            class="full-width"
            data-testid="patient-side-panel-content-notes-f2h9w5mb"></lib-note-list>
    }
    @if (openedTabs().has(SegmentType.TASK)) {
        <task-list
            (tasksChanged)="tasksChange.emit()"
            [class.ion-hide]="shownTab() !== SegmentType.TASK"
            [filterSettingName]="taskListFilterSettingName"
            [sharedFilterSettingName]="TASK_LIST_FILTER_SETTING_NAME"
            [patient]="currentPatient()"
            class="full-width"
            data-testid="patient-side-panel-content-tasks-z7c1q3vr"></task-list>
    }
    @if (openedTabs().has(SegmentType.MAIN_INFORMATION)) {
        <user-main-info
            (userChange)="onPatientChange($event)"
            [class.ion-hide]="shownTab() !== SegmentType.MAIN_INFORMATION"
            data-testid="patient-side-panel-content-main-info-t4g8k2ye"
            [config]="config"
            [mainUserRole]="UserRoles.PATIENT"
            [user]="currentPatient()">
        </user-main-info>
    }
</ion-content>
